import { defineComponent as _defineComponent } from 'vue'
import { PurchaseDetails } from '@/components/Billing/billing-types';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

export default /*#__PURE__*/_defineComponent({
  __name: 'SeeBreakdownButton',
  props: {
    newPurchaseDetails: null,
    currentPurchaseDetails: null
  },
  setup(__props: any) {

const props = __props as {
	newPurchaseDetails: PurchaseDetails;
	currentPurchaseDetails: PurchaseDetails;
}



const openPricingBreakdownDialog = () => {
	AppDialogManagerService.openPricingBreakdownDialog({
		newPurchaseDetails: props.newPurchaseDetails,
		currentPurchaseDetails: props.currentPurchaseDetails,
	});
};

return { __sfc: true,props, openPricingBreakdownDialog }
}

})